/* eslint-disable react/no-unescaped-entities */
import { Link } from "react-router-dom";
import { LegalPage, Section, BulletList } from "../components/LegalPage";

const reopen = () => window.dispatchEvent(new CustomEvent("sbi:open-cookie-prefs"));

export default function Cookies() {
  return (
    <LegalPage
      title="Cookie Policy"
      updated="26 February 2026"
      intro="This Cookie Policy explains what cookies and similar browser-storage technologies ShouldIBuyIt.co.uk uses, what each is for, and how you can manage your preferences. It supplements our Privacy Policy."
    >
      <Section title="1. What are cookies?">
        <p>
          A cookie is a small text file stored in your browser when you visit a website. Many sites also use
          <em> local storage</em>, which is similar but is never automatically sent back to the server. Both are
          subject to the UK Privacy and Electronic Communications Regulations (PECR) and the UK GDPR, and we
          treat them the same way here.
        </p>
      </Section>

      <Section title="2. The categories we use">
        <p><strong>Essential</strong> — required for the site to function. These cannot be turned off.</p>
        <BulletList items={[
          "sbi_theme — remembers your dark / light theme choice.",
          "sbi_history — your recent chat history, visible only to you on your device.",
          "sbi_admin_token — sign-in token, only set after admin sign-in.",
          "sbi_cookie_consent — records the cookie choice you made here.",
        ]} />

        <p className="mt-4"><strong>Functional</strong> — none currently set. We would describe and request consent before any are added.</p>

        <p className="mt-4"><strong>Analytics</strong> — none currently set. If we ever enable privacy-respecting analytics (for example, Plausible) we will list each cookie here and only load the script if you have opted in via the banner.</p>

        <p className="mt-4"><strong>Affiliate / marketing</strong> — when you click an Amazon link, Amazon sets its own cookies on its domain so it can attribute the eventual purchase. Those cookies are governed by Amazon's privacy and cookie policies. We do not set any marketing cookies ourselves.</p>

        <p className="mt-4"><strong>Third-party</strong> — none load on our pages without your consent. We do not embed third-party trackers, social-media pixels, or ad networks.</p>
      </Section>

      <Section title="3. How to manage your preferences">
        <p>
          You can change your cookie preferences at any time by opening the banner again:{" "}
          <button onClick={reopen} className="text-emerald-500 underline">Open cookie preferences</button>.
        </p>
        <p>
          You can also delete cookies and local storage entries directly from your browser's settings. Doing so
          will reset your theme preference and chat history.
        </p>
      </Section>

      <Section title="4. Browser controls">
        <BulletList items={[
          "Chrome: Settings → Privacy and security → Third-party cookies / Site data.",
          "Safari: Settings → Privacy → Manage Website Data.",
          "Firefox: Settings → Privacy & Security → Cookies and Site Data.",
          "Edge: Settings → Cookies and site permissions.",
        ]} />
      </Section>

      <Section title="5. Changes to this policy">
        <p>
          We will update this page whenever the set of cookies or storage items we use changes. Material changes
          will trigger the cookie banner to re-appear so you can review your choice.
        </p>
      </Section>

      <Section title="6. Further reading">
        <p>
          See also our <Link to="/privacy" className="text-emerald-500 underline">Privacy Policy</Link> for the
          wider data-protection context.
        </p>
      </Section>
    </LegalPage>
  );
}
